module.exports = __webpack_public_path__ + "img/民诉法.7839cb97.png";